export default [
  { to: 'other', title: 'Fältsmart' },
  { to: 'polislagen', title: 'Lagstöd' },
  { to: 'health', title: 'Polisnyttigt' },
  { to: 'polisanstallda', title: 'Polisanställda' },
  { to: 'ovrigt', title: 'Övrigt' },
  { to: 'external_links', title: 'Externa Länkar' },
  { to: 'faq', title: 'FAQ' },
];
